"use client";
import { useScrollToTop } from "@/hooks";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { useRouter } from "next/navigation";

export const HeroHeaderDefault = () => {
  const t = useTranslations();
  const navigate = useRouter();
  useScrollToTop();
  const scrollDown = () => {
    window.scrollTo({
      top: screen.height - 120,
      behavior: "smooth",
    });
  };

  return (
    <div className="sm:pt-[250px] heroHeader sm:pb-[340px] sm:h-screen-minus-88 max-h-[100vh] sm:text-[24px]   sm:leading-[55px] sm:tracking-[0.2px] relative flex flex-col justify-center items-center mx-auto lg:px-[20vw] lg:py-[100px] text-center text-slate-700 h-screen-minus-90">
      <h1 className="sm:mb-4 sm:px-4 md:text-xlg lg:text-xxlg font-medium mb-8 px-10">
        {t("heroHeader1")}
        <span className="sm:mx-4 md:mx-6 text-blue-600 relative lg:mx-[30px] text-5 whitespace-nowrap">
          {t("heroHeader2")}
          <i className="absolute sm:top-[-20px] sm:left-[-15px] md:left-[-18px] md:top-[-25px] lg:top-[-25px]">
            <Image
              width={278}
              height={120}
              quality={50}
              alt="Home-image"
              className="max-w-[110%] max-h-[110%]"
              src="/icons/easier.svg"
            />
          </i>
        </span>
        {t("heroHeader3")}
      </h1>
      <p className="sm:px-4 sm:text-base sm:mb-8 font-normal leading-10  text-slate-500 lg:text-[20px] lg:px-[140px] mb-12">
        {t("ourTeamAvailable")}
      </p>
      <button
        onClick={() => navigate.push("/get-quote")}
        className="border-[3px] border-[#A271F2] px-8 py-5 rounded-lg text-blue-600 text-[16px] leading-[10px] font-medium md:mb-[153px]"
      >
        {t("createWebsite")}
      </button>
      <i className="cursor-pointer absolute bottom-10" onClick={scrollDown}>
        <span className="scroll__items">
          <Image
            width={30}
            height={50}
            alt="Home-image"
            src="/icons/check.svg"
          />
          <span className="absolute top-2 left-2 scroll__items-circle">
            <Image
              width={14}
              height={14}
              className="max-w-[14px] max-h-[14px]"
              alt="Home-image"
              src="/icons/circle.svg"
            />
          </span>
        </span>
      </i>
    </div>
  );
};
